import { useActiveFilters } from '../../context/ActiveFiltersContext';
import { X, Filter } from 'lucide-react';

/**
 * Compact strip of dismissable filter chips sourced from `ActiveFiltersContext`.
 * Renders nothing when no filters are active (so it never takes space).
 */
const FilterPillStrip = () => {
  const { activeFilters } = useActiveFilters();
  if (!activeFilters || activeFilters.length === 0) return null;

  return (
    <div
      className="flex items-center gap-1.5 flex-wrap max-w-md"
      data-testid="filter-pill-strip"
    >
      <Filter className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
      {activeFilters.map((f) => (
        <span
          key={`${f.label}-${f.value}`}
          className="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-full bg-[#111565]/10 text-[#111565] text-xs font-medium"
          data-testid={`filter-pill-${String(f.label).toLowerCase().replace(/\s+/g, '-')}`}
        >
          <span className="whitespace-nowrap">
            <span className="text-muted-foreground mr-1">{f.label}:</span>
            <span className="font-semibold">{f.value}</span>
          </span>
          {f.onClear && (
            <button
              type="button"
              onClick={f.onClear}
              className="p-0.5 rounded-full hover:bg-[#111565]/20 transition"
              aria-label={`Clear ${f.label} filter`}
              data-testid={`filter-pill-clear-${String(f.label).toLowerCase().replace(/\s+/g, '-')}`}
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </span>
      ))}
    </div>
  );
};

export default FilterPillStrip;
